<template>
  <div id="app">
    <Header></Header>
    <div class="main-container">
      <Pre-page :nav="prePageNav"></Pre-page>
      <div class="articleList-container">
        <div class="articleList-content">
          <div class="articleList">
            <div class="crop-title">{{ research.subject }}</div>
            <div class="crop-infos">
              <div class="crop-info-item">
                <span>日期：{{ research.createTime | timeAgo }}</span>
              </div>
              <div class="crop-info-item">
                <span>作者：{{ research.name | nameNoPhone }}</span>
              </div>
              <div class="crop-info-item">
                <span>浏览量：{{ research.clickViews }}</span>
              </div>
            </div>
            <!-- <div class="bar_"></div> -->
            <div class="product-cont">
              <div v-html="research.content"></div>
            </div>
            <Adv></Adv>
            <div class="research-links">
              <div class="research-link">
                <span>上一篇</span><a v-if="!prevResearch">无</a
                ><a
                  :href="
                    'yyal.html?id=' +
                    prevResearch.researchId
                  "
                  v-else
                  >{{ prevResearch.subject }}</a
                >
              </div>
              <div class="research-link">
                <span>下一篇</span><a v-if="!nextResearch">无</a
                ><a
                  :href="
                    'yyal.html?id=' +
                    nextResearch.researchId
                  "
                  v-else
                  >{{ nextResearch.subject }}</a
                >
              </div>
            </div>
            <AboutResearch :list="aboutR"></AboutResearch>
            <OneTitle
              :title="`共${totalpage}条评论`"
              :showComment="true"
              @addComment="addComment"
            ></OneTitle>
            <div class="comment-area" v-loading="loading">
              <div class="comment-list">
                <Comment
                  :comment="comment"
                  v-for="comment in comments"
                  :key="comment.commentResearchId"
                  @reply="reply"
                ></Comment>
              </div>
            </div>
            <div
              style="
                margin: 24px 0 40px;
                display: flex;
                justify-content: center;
              "
            >
              <Pagination
                :totalpage="totalpage"
                @pageChange="pageChange"
              ></Pagination>
            </div>
          </div>

          <div class="likeList">
            <Like :list="cardList"></Like>
          </div>
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from "../components/header.vue";
import Footer from "../components/footer.vue";
import Pagination from "../components/pagination.vue";
import Like from "../components/likeList.vue";
import PrePage from "../components/PrePage.vue";
import OneTitle from "../components/OneTitle.vue";
import Comment from "../components/Comment.vue";
import Adv from "../components/adv.vue";
import AboutResearch from "../components/aboutResearch.vue";

export default {
  name: "app",
  components: {
    Header,
    Footer,
    Pagination,
    Like,
    PrePage,
    OneTitle,
    Comment,
    Adv,
    AboutResearch,
  },
  data: () => {
    function getUrlString() {
      var urlStr = window.location.search; //?sex=man&age=20
      console.log(urlStr);
      if (urlStr != null && urlStr.toString().length > 1) {
        var myUrlStr = urlStr.substr(1); //sex=man&age=20
        var array1 = myUrlStr.split("&"); //["sex=man"],["age=20"]
        var getString = {};
        for (var i = 0; i < array1.length; i++) {
          getString[array1[i].split("=")[0]] = array1[i].split("=")[1]; //["sex","man"]["age","20"]
        }
        return getString;
      } else {
        console.log("无参数");
      }
    }
    var gus = new getUrlString();
    console.log(gus);

    return {
      totalpage: 10,
      currentpage: 1,
      loading: false,

      cardType: "0", //0 农技文章
      research: {
        createTime: "",
      },
      comments: [],
      prePageNav: [
        {
          name: "首页",
          to: "/",
        },
        {
          name: "应用案例",
          to: "zwal.html",
        },
        {
          name: "详情",
          to: "",
        },
      ],
      cardList: [
        {
          title: "",
          desc: "",
          author: "",
          time: "",
          clickViews: 10,
          imgUrl: "",
        },
      ],
      researchId: gus.id,
      productId: gus.productId || "",
      cropId: gus.cropId,
      prevResearch: {},
      nextResearch: {},
      aboutR: [],
    };
  },
  beforeMount() {
    // this.$axios
    //   .get(`post/findResearch?researchId=${this.researchId}`)
    //   .then((res) => {
    //     console.log(res);
    //     this.research = res.data.information;
    //   });
    this.$axios
      .get(
        `post/showResearch?researchId=${
          this.researchId
        }&status=1&articleAreaId=${this.cropId || ""}&productId=${
          this.productId || ""
        }`
      )
      .then((res) => {
        console.log(res);
        this.research = res.data.information[0].researchEntity;
        // this.crop = this.research.areaName;
        this.prevResearch = res.data.information[0].upResearch;
        this.nextResearch = res.data.information[0].moveResearch;
        this.aboutR = res.data.information[0].groupArticleList;
        this.cardList = res.data.information[0].articleList;
        document.getElementsByTagName('title')[0].innerHTML = this.research.subject;
      });

    this.$axios
      .post(
        `https://m.nongjike.cn/app/community/findComment?userId=1&researchId=${this.researchId}&pageNum=1&pageSize=10`
      )
      .then((res) => {
        this.comments = res.data.information.list;
        this.totalpage = res.data.information.total;
      });
  },
  methods: {
    reply(item, status, commentid) {
      let USER = !sessionStorage["USER"]
        ? {}
        : JSON.parse(sessionStorage["USER"]);
      if (!USER || !USER.userId) {
        this.$alert("请先登录", "提示");
      } else if (status == 0) {
        this.$prompt("请输入评论内容", "回复" + item.nickName, {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          inputType: "textarea",
        }).then(({ value }) => {
          if (!value) {
            return this.$message.error("评论内容不能为空");
          }
          this.$axios
            .post(
              `https://m.nongjike.cn/app/community/commentResearchReply`,
              {},
              {
                params: {
                  userId: USER.userId,
                  message: value,
                  researchId: this.id,
                  commentResearchId: item.commentResearchId,
                },
              }
            )
            .then((res) => {
              let data = res.data;
              if (data.status == 200) {
                this.$message.success("评论成功！");
                this.pageChange(1);
              } else {
                this.$message.error("评论失败！" + data.message);
                this.showsend = false;
              }
            });
        });
      } else if (status == 1) {
        this.$prompt("请输入评论内容", "回复" + item.nickName, {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          inputType: "textarea",
        }).then(({ value }) => {
          if (!value) {
            return this.$message.error("评论内容不能为空");
          }
          this.$axios
            .post(
              `https://m.nongjike.cn/app/community/commentResearchReplys`,
              {},
              {
                params: {
                  userId: USER.userId,
                  message: value,
                  researchId: this.id,
                  pid: commentid,
                  replyId: item.userId,
                },
              }
            )
            .then((res) => {
              let data = res.data;
              if (data.status == 200) {
                this.$message.success("评论成功！");
                this.pageChange(1);
              } else {
                this.$message.error("评论失败！" + data.message);
                this.showsend = false;
              }
            });
        });
      }
    },
    addComment() {
      let USER = !sessionStorage["USER"]
        ? {}
        : JSON.parse(sessionStorage["USER"]);
      if (!USER || !USER.userId) {
        this.$alert("请先登录", "提示");
      } else {
        this.$prompt("请输入评论内容", "评论", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          inputType: "textarea",
        }).then(({ value }) => {
          if (!value) {
            return this.$message.error("评论内容不能为空");
          }
          this.$axios
            .post(
              `https://m.nongjike.cn/app/community/saveCommentResearch`,
              {},
              {
                params: {
                  userId: USER.userId,
                  message: value,
                  researchId: this.id,
                  img: "",
                },
              }
            )
            .then((res) => {
              let data = res.data;
              if (data.status == 200) {
                this.$message.success("评论成功！");
                this.pageChange(1);
              } else {
                this.$message.error("评论失败！" + data.message);
                this.showsend = false;
              }
            });
        });
      }
    },
    pageChange(n) {
      console.log(n);
      this.loading = true;
      this.$axios
        .post(
          `https://m.nongjike.cn/app/community/findComment?userId=1&researchId=${this.researchId}&pageNum=${n}&pageSize=10`
        )
        .then((res) => {
          this.comments = res.data.information.list;
          this.loading = false;
          //   this.totalpage = res.data.information.total
        });
    },
  },
  filters: {
    nameNoPhone(nickName) {
      if (!nickName) {
        return nickName;
      } else {
        nickName = nickName.replace(/\d{11}/gi, "***");
        return nickName;
      }
    },
    upTo5(num) {
      num = parseInt((num - 0) * 5);
      if (num - 10000 > 0) {
        num = parseInt(num / 10000) + "w+";
      }
      return num;
    },
    timeAgo(time) {
      let between = Date.now() / 1000 - new Date(time).getTime() / 1000;
      if (between < 0) {
        between += 25200;
      }
      if (between < 3600) {
        return `${~~(between / 60)} 分钟前`;
      } else if (between < 86400) {
        return `${~~(between / 3600)} 小时前`;
      } else {
        return `${time.split(" ")[0]}`;
      }
    },
  },
  mounted: () => {},
};
</script>

<style lang="scss">
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
  color: #2c3e50;
  margin-top: 121px;
}
a {
  & > * {
    text-decoration: none;
  }
  text-decoration: none;
}
video {
  width: 100%;
}
.image-slot {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #f5f5f5;
  img {
    width: 50%;
    height: auto;
    display: block;
  }
}

.main-container {
  width: 100%;
  .header-bg {
    width: 100%;
    display: block;
  }
}
.research-links {
  margin: 40px 0;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .research-link {
    width: 45%;
    text-align: left;
    vertical-align: bottom;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    span {
      font-size: 14px;
      color: #666;
      margin-right: 16px;
    }
    a {
      color: #333;
      font-size: 16px;
    }
  }
}
.articleList-container {
  width: 100%;
  background: #fff;
  .articleList-content {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    flex-wrap: nowrap;
    justify-content: flex-start;
    align-items: flex-start;
    padding-top: 30px;
    .articleList {
      width: 100px;
      flex-grow: 1;
      margin-right: 54px;
    }

    .likeList {
      width: 360px;
    }
  }
}

.product-cont {
  width: 100%;
  overflow: hidden;
  margin: 22px 0;
  img {
    max-width: 100%;
    display: block;
    height: auto !important;
  }
  video {
    max-width: 100%;
    width: 100%;
  }
}
.crop-title {
  font-size: 24px;
  color: #1f1f1f;
  padding-top: 20px;
  text-align: center;
  margin-bottom: 12px;
}
.crop-times {
  padding-bottom: 40px;
}
.crop-infos {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 22px;
  .crop-info-item {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-wrap: nowrap;
    color: #999;
    font-size: 14px;
    margin-left: 8px;
    line-height: 20px;
    margin-right: 15px;
    .iconfont {
      font-size: 16px;
      margin-right: 4px;
    }
    img {
      width: 16px;
      height: 16px;
      margin-right: 4px;
    }
  }
}
.bar_{
  width: 50%;
  height: 2px;
  border-radius: 2px;
  background: #dedede;
  margin: 20px auto;
}
@media screen and (max-width: 1200px) {
  #app {
    margin-top: 91px;
  }
  .login_container {
		padding-left: 10px;
	}
	.headers {
		width: 100%;
		padding-left: 10px;
	}
	#app {
		overflow: hidden;
	}
	#app .headers .header-nav {
		display: none;
	}

  .crop-selector-container .crop-selector{
    width: 100%;
  }
  .crop-selector-container .crop-selector .crop-item .crop-group{
    margin-right: 0;
    font-size: 14px;
  }
  .crop-selector-container .crop-selector .crop-item .crop-titles{
    font-size: 14px;
    line-height: 20px;
    a{
      min-width: 80px;
      margin-bottom: 6px;
    }
  }
  .crop-selector-container{
    padding: 20px 10px 14px;
  }
  .likeList{
    display: none;
  }
  .articleList-container .articleList-content{
    width: 100%;
    padding-left: 10px;
    padding-right: 10px;
    .articleList{
      margin-right: 0;
      padding: 0 10px;
    }
  }
  .crop-infos{
    flex-wrap: wrap;
    .crop-info-item{
font-size: 12px;
margin-right: 10px;
    }
    
  }
}
</style>
